export default "__VITE_ASSET__b8344920__"